import { APIGet } from "../services/API";

const chatroomLimit = 50;

const getOlderMessageID = (messages) => {
    messages.map() 
}

export const addMessage = (room,auth,msg) => (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    // Delete Old Messages
    const messages = getState().firestore.data[room+'-messages'];
    if(messages){
        const cleanMessages = Object.keys(messages).filter(key => !!messages[key]);
        if(cleanMessages.length > chatroomLimit){
            dispatch(permanentlyDeleteMessage(room,cleanMessages[0]));
        }
    }

    // Add New Messages
    firestore.collection('chatrooms/'+room+'/messages').add({
        m: msg,
        // uid: auth.uid,
        // un: (!auth.displayName) ? auth.email : auth.displayName,
        ip: auth.ip,
        un: auth.username,
        createdAt: firestore.FieldValue.serverTimestamp()
    })
    return;
}


export const deleteMessage = (room,mid) => (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    firestore.collection('chatrooms/'+room+'/messages').doc(mid).update({'m':'deleted'});
    return;
}

export const permanentlyDeleteMessage = (room,mid) => (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    firestore.collection('chatrooms/'+room+'/messages').doc(mid).delete();
    return;
}

export const formatChatroom = (fbDoc) => {
    return {
        id: fbDoc.id,
        data: fbDoc.data()
    }
}

export const setupChatroom = (roomId) => async (dispatch, getState, { getFirebase, getFirestore }) => {
        
    const firestore = getFirestore();
    
    firestore.collection('chatrooms').where("name", "==", roomId).get().then((querySnapshot)=> {

        if(querySnapshot.docs.length <= 0){
           
            // Create a Room
            dispatch(createChatroom(roomId));

        } else {
            // Return Doc
            dispatch({
                type: 'CONFIGURE_CHATROOM',
                chatroom: formatChatroom(querySnapshot.docs[0])
            })
        }
        
    }).catch((err) => {
        console.log(err,"SETING ROOM")
    })

}


export const createChatroom = (roomId) => (dispatch, getState, { getFirebase, getFirestore }) => {

    const firestore = getFirestore();

    firestore.collection('chatrooms').doc(roomId).set({
            name: roomId,
            createdAt: new Date()
        }).then((doc)=>{
            dispatch({
                type: 'CONFIGURE_CHATROOM',
                chatroom: formatChatroom(doc)
            })

        }).catch((err) => {
            // Dispatch Action
            dispatch({
                type: 'CREATE_CHATROOM_ERROR',
                err
            })
        })
}

export const logOut = (auth) => (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    firebase.logout();   
    return;
}

export const validateUser = () => dispatch => {

    const user = JSON.parse(window.localStorage.getItem('user'))
    if(!user) return;
    
    if(user.username) {       
        dispatch(localLogin(user.username))
    } else {
        // DO Nother
    }

}

export const localLogin = (username) => dispatch => {

    APIGet("https://api.ipify.org?format=json")
    .then(res => res.json())
    .then(json => {

        const user = {
            username,
            ip: json.ip
        }
        // Write to local storage
        window.localStorage.setItem('user', JSON.stringify(user));

        // Return
        dispatch({
            type: 'CHATROOM_SET_USERNAME',
            payload: {
                username,
                ip: json.ip
            }
        });

    })
    .catch(e => {
        dispatch({ type: 'CHATROOM_SET_USERNAME_ERROR',payload: {ui:"error",message:e}});
    })

}

// TODO: Local Logout needed
export const localLogout = () => dispatch => {

    window.localStorage.removeItem('user');
    dispatch({
        type: 'CHATROOM_LOGOUT',
        payload: {
        }
    });

}



export const blockUser = (room,ip) => (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    // Block an IP Address
    firestore.collection('chatrooms/'+room+'/blocked').add({
        ip: ip,
        createdAt: firestore.FieldValue.serverTimestamp()
    })
    return;
}

export const unBlockUser = (room,bid) => (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    firestore.collection('chatrooms/'+room+'/blocked').doc(bid).delete();
    return;
}

export const clearRoom = (room) => (dispatch, getState, { getFirebase, getFirestore }) => {
    const messages = getState().firestore.data[room+'-messages'];
    if(messages){
       Object.keys(messages).map(key => {
           if(messages[key]) dispatch(permanentlyDeleteMessage(room,key));
       });
        
    }
}